import clsx from 'clsx'

import { css } from '@codemirror/lang-css'
import ReactCodeMirror from '@uiw/react-codemirror'

interface Props {
  value?: string
  onChange: (value: string) => void
  placeholder?: string
  height?: string
  error?: boolean
  disabled?: boolean
  noBorder?: boolean
}

const CodeTextarea = ({
  value = '',
  onChange,
  placeholder,
  height = '200px',
  error = false,
  disabled = false,
  noBorder = false
}: Props) => {
  return (
    <div
      className={clsx(
        'w-full rounded-lg text-xs',
        error ? 'border-critical-secondary' : 'border-border-input',
        !noBorder && 'border-primary overflow-hidden border'
      )}
    >
      <ReactCodeMirror
        value={value}
        onChange={onChange}
        extensions={[css()]}
        placeholder={placeholder}
        height={height}
        editable={!disabled}
        basicSetup={{
          lineNumbers: true,
          foldGutter: false,
          dropCursor: false,
          allowMultipleSelections: false,
          indentOnInput: true,
          bracketMatching: true,
          closeBrackets: true,
          autocompletion: true,
          highlightActiveLine: true
        }}
      />
    </div>
  )
}

export default CodeTextarea
